export default {
      id: "sli-browse-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.9328ef59.svg#sli-browse",
      toString: function () {
        return this.url;
      }
    }